<template>
  <div>
    <!-- <div class="content mt-3"> -->
    <!-- <template slot="title">
        <div class="header_t">
          <img :src="$_c + 'favicon.ico'" alt="logo" height="3%" width="3%" />
          <span class="ml-3">广 东 志 正 快 速 采 购 平 台</span>
          <span class="ml-2" style="color: red">{{ tip }}</span>
        </div>
      </template>
      <div class="content">
        <div v-for="(item, i) in messageList" :key="i" class="mt-1">
          <div style="color: #a1a5a7">
            {{ item.sendMc ? item.sendMc : "广东志正快速采购平台" }}
            {{ item.sendTime | moment }}
          </div>
          <div style="background: #ffffff; padding: 12px">{{ item.content }}</div>
        </div>
      </div>
      <div class="footer">
        <a-textarea
          v-model="formData.content"
          placeholder="请描述您的问题，将此问题发给经办人"
          :rows="4"
        />
        <div class="sendBtn">
          <a-button size="small" @click="send" type="primary">发送</a-button>
        </div>
      </div> -->
    <!-- <div>{{ messageList.content }}</div> -->

    <!--  <div v-for="(item, i) in messageList" :key="i" class="mt-1">
        <div style="background: #ffffff; padding: 12px">{{ item.content }}</div>
        <div style="color: white; display: flex; justify-content: flex-end">
          {{ dayFromNow(item.sendTime) }}
        </div>
      </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import * as dayjs from 'dayjs'
import 'dayjs/locale/zh-cn' // 导入本地化语言
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
dayjs.locale('zh-cn')
export default {
  props: ['packId', 'resultDataLength'],
  data () {
    return {
      tip: '',
      messageList: [],
      formData: {
        xmid: this.$route.query.projectId,
        bzid: '',
        content: '',
        sendId: this.$ls.get('user').id,
        sendTime: '',
        sendMc: this.$ls.get('user').supplierName
      },
      socketUrl: process.env.VUE_APP_API_SERVER + '/webSocket',
      socket: '',
      stompClient: null,
      reconInv: ''
    }
  },
  computed: {
    dayFromNow () {
      return function (day) {
        return dayjs(day).fromNow()
      }
    }
  },
  watch: {
    packId: {
      handler (val) {
        let webSocketConnectCount = this.$ls.get(this.$route.query.projectId)
        let packLength = this.$ls.get('packLength')
        if (webSocketConnectCount < packLength || webSocketConnectCount == null) {
          this.initWebSocket()
        }
      }
    }
  },
  mounted () {
    // this.initWebSocket()
    this.initChatMessage()
  },
  beforeDestroy () {
    this.stompClient.disconnect()
    clearInterval(this.reconInv)
  },
  methods: {
    initChatMessage (packId) {
      this.$http
        .get(
          '/api/1/competitiveChat/getListByXmid.json?xmid=' + this.$route.query.projectId
        )
        .then((res) => {
          this.messageList = res.result
        })
    },
    /* send () {
      // 系统抽签准备消息传达
      this.tip = ''
      if (this.formData.content == '' || this.formData.content == null) {
        this.tip = '发送内容不能为空'
      } else {
        this.formData.sendTime = new Date()
        this.$http
          .post(
            '/api/v1/supplier/socket/prepare_draw_message.json',
            qs.stringify(this.formData)
          )
          .then(function (res) {
            console.log(res)
          })
      }
    }, */
    initWebSocket () {
      let webSocketConnectCount = this.$ls.get(this.$route.query.projectId)
      if (webSocketConnectCount != null) {
        console.log(webSocketConnectCount)
        this.$ls.set(this.formData.xmid, webSocketConnectCount += 1)
      } else {
        this.$ls.set(this.formData.xmid, 1)
      }
      // 初始化websocket操作
      this.socket = new SockJS(this.socketUrl)
      this.stompClient = Stomp.over(this.socket)
      this.stompClient.debug = null // 关闭浏览器控制台中 日志打印
      this.stompClient.connect(
        {},
        (frame) => {
          this.successCallback() // 连接成功时，回调
        },
        (error) => {
          // 连接失败时回调
          this.reconnect(this.socketUrl, this.successCallback) // 此处调用重连方法
        }
      )
    },
    reconnect (socketUrl, successCallback) {
      // 断开重连使用定时器定时连接服务器
      this.reconInv = setInterval(() => {
        this.socket = new SockJS(socketUrl)
        this.stompClient = Stomp.over(this.socket)
        this.stompClient.connect(
          {},
          (frame) => {
            clearInterval(this.reconInv) // 连接成功，清除定时器
            successCallback()
          },
          (error) => {
            // this.$message.warning("服务重连中,请勿操作!")
            //   this.sysWarning("服务重连中,请勿操作!");
          }
        )
      }, 5000)
    },
    successCallback () {
      // 连接成功
      let projectId = this.$route.query.projectId
      let webSocketConnectCount = parseInt(this.$ls.get(projectId))
      if (webSocketConnectCount === 1) {
        this.stompClient.subscribe(
          '/topic/prepare_draw/' + projectId,
          this.onMessageReceived
        )
      }
      let packId = this.packId
      this.stompClient.subscribe('/topic/draw/' + packId, this.onMessageResultReceived)
    },
    onMessageResultReceived (payload) {
      this.$emit('onMessageResult', payload)
    },
    onMessageReceived (payload) {
      // 接收到消息并对消息做处理
      // console.log("连接成功");
      //  console.log(payload.body);
      if (payload.body !== undefined || payload.body !== false) {
        var list = JSON.parse(payload.body)
        this.messageList.unshift(list)
        this.$notification['info']({
          message: '温馨提示',
          description: list.content,
          duration: 0
        })
        /* let secondsToGo = 10;
        const modal = this.$info({
          title: "温馨提示",
          okText:10,
          content: list.content,
          okButtonProps: {
            props: { disabled: true },
          },
        });
        const interval = setInterval(() => {
          secondsToGo -= 1;
          modal.update({
            okText: `${secondsToGo}`,
          });
        }, 1000);
        setTimeout(() => {
          clearInterval(interval);
          modal.destroy();
          this.$emit("modalCancel")
        }, secondsToGo * 1000); */
        /*  this.messageList.push({
          content: list.content,
          sendTime: list.sendTime,
          sendMc: list.sendMc,
        }); */
        // this.messageList = list;
      }
    }
  }
}
</script>

<style scoped>
.content {
  padding: 24px 16px 20px;
  background: #c0bebe;
  height: 13vw;
  overflow-y: auto;
}
.sendBtn {
  padding: 5px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
/*-------滚动条整体样式----*/
.content::-webkit-scrollbar {
  width: 4px;
}

/*滚动条里面小方块样式*/
.content::-webkit-scrollbar-thumb {
  border-radius: 100px;
  background: #d1d1d1;
}

/*滚动条里面轨道样式*/
.content::-webkit-scrollbar-track {
  border-radius: 0;
  background: #d1d1d1;
}
</style>
